import axios from 'axios'
import $store from '@/store'
import iStoreSetting from '@/scripts/istore-setting'
import iStoreLocalData from '@/scripts/istore-local-data'
import iStoreUtils from '@/scripts/istore-utils.js'
import $router from '@/router/index.js';
import { langControl } from '@/scripts/istore-ui-lang.js'

// Handle all "User Not Authorized" with axios.interceptors
axios.interceptors.response.use(
  rs => {
    return Promise.resolve(rs);
  },
  rs => {
    if (iStoreLocalData.isAuthenticated()) {
      console.debug('#[axios.interceptors.response]', rs)
      if (rs.response.data && rs.response.data.result === '902') {
        $store.commit('setLogoutClicked', true)
        $store.commit('setLoginTimestamp', 0)
        iStoreLocalData.setAuthenticated(false)
        iStoreLocalData.removeAll()
        $router.push({path: '/'})
        alert(rs.response.data.message)
        return
      }
    }
    return Promise.resolve(rs);
  });

window._axios = axios

export default {
  retry: 0,
  // Get token for request header, retrieve from localStorage first
  async getToken(isRetry = false) {
    let token
    if (!isRetry) {
      token = iStoreLocalData.getToken()
      if (token) {
        return token
      }
    } else {
      this.retry++
      if (this.retry > 3) {
        alert(this.langKey.notifGetTokenError)
        return
      }
    }
    const url = `${iStoreSetting.iStoreUrl}/gettoken`
    const result = await axios.get(url)
    if (result.data) {
      token = result.data.token
      iStoreLocalData.setToken(token)
      this.retry = 0
      return token
    }
    throw new Error('Can\'t get token!!')
  },
  async getTokenCloud(isRetry = false) {
    let token
    if (!isRetry) {
      token = iStoreLocalData.getToken()
      if (token) {
        return token
      }
    } else {
      this.retry++
      if (this.retry > 3) {
        alert(this.langKey.notifGetTokenError)
        return
      }
    }
    const url = `${iStoreSetting.iStoreCloud}/gettoken`
    const result = await axios.get(url)
    if (result.data) {
      token = result.data.token
      iStoreLocalData.setToken(token)
      this.retry = 0
      return token
    }
    throw new Error('Can\'t get token!!')
  },
  // Get define data from istoreui.db
  async getDefines(parent = null, module = null, name = null) {
    try {
      const token = await this.getToken()
      let url
      if (module !== null && name !== null) {
        url = `${iStoreSetting.iStoreUrl}/search/istoreui/istoreui.func.${parent}.${module}.${name}`
      } else {
        url = `${iStoreSetting.iStoreUrl}/search/istoreui/istoreui.func.`
      }
      const result = await axios.get(url, {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.error(error)
      return null
    }
  },
  // Save new node to define key in istoreui.db
  async saveNewNode(value) {
    try {
      const {parent, module, name} = value
      const data = {
        key: `istoreui.func.${parent}.${module}.${name}`,
        value: JSON.stringify(value),
      }
      const token = await this.getToken()
      const url = `${iStoreSetting.iStoreUrl}/istoreui`
      const result = await axios.put(url, data, {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.error(error)
      return null
    }
  },
  // Delete newly-added node in define key in istoreui.db
  async deleteNewNode(value) {
    try {
      const token = await this.getToken()
      const {parent, module, name} = value
      const url = `${iStoreSetting.iStoreUrl}/istoreui/istoreui.func.${parent}.${module}.${name}`
      const result = await axios.delete(url, {
        headers: {Token: token},
      })
      return result.status === 200
    } catch (error) {
      console.error(error)
      return false
    }
  },
  // Search db by keyprefix (supports pagination)
  async searchKeyPrefix(db, key, row = null, page = null, sortBy = null, sortOrder = null) {

    db = this.changeDatabaseNameByCid(db)

    try {
      const token = await this.getToken()
      let url
      if (row !== null && page !== null) {
        page = row * (page - 1)
        url = `${iStoreSetting.iStoreUrl}/searchkeyprefix/${db}/${key}/${row}/${page}`
      } else {
        url = `${iStoreSetting.iStoreUrl}/searchkeyprefix/${db}/${key}`
      }
      const params = {}
      if (sortBy) params.sortBy = sortBy.trim()
      if (sortOrder) params.sortOrder = sortOrder.trim()

      const result = await axios.get(url, {
        headers: { Token: token },
        params
      })
      // const result = await axios.get(url, {
      //   headers: {Token: token},
      // })
      return result.data
    } catch (error) {
      console.error(error)
      return null
    }
  },
  // Search db by keyprefix in cloud database(supports pagination)
  async searchKeyPrefixCloud(db, key, row = null, page = null, sortBy = null, sortOrder = null) {

    db = this.changeDatabaseNameByCid(db)

    try {
      const token = await this.getToken()
      let url
      if (row !== null && page !== null) {
        page = row * (page - 1)
        url = `${iStoreSetting.iStoreCloud}/searchkeyprefix/${db}/${key}/${row}/${page}`
      } else {
        url = `${iStoreSetting.iStoreCloud}/searchkeyprefix/${db}/${key}`
      }
      const params = {}
      if (sortBy) params.sortBy = sortBy.trim()
      if (sortOrder) params.sortOrder = sortOrder.trim()

      const result = await axios.get(url, {
        headers: { Token: token },
        params
      })
      // const result = await axios.get(url, {
      //   headers: {Token: token},
      // })
      return result.data
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async searchKeyPrefixCount(db, key) {

    db = this.changeDatabaseNameByCid(db)

    try {
      const token = await this.getToken()
      let url = `${iStoreSetting.iStoreUrl}/searchkeyprefix/${db}/${key}/count`
      const result = await axios.get(url, {
        headers: {Token: token},
      })
      return parseInt(result.data.count)
    } catch (error) {
      console.error(error)
      return 0
    }
  },
  async searchKeyPrefixAndCondition(db, key, query) {

    db = this.changeDatabaseNameByCid(db)

    try {
      const token = await this.getToken()
      let url = `${iStoreSetting.iStoreUrl}/searchKeyPrefixAndCondition/${db}/${key}`
      const result = await axios.post(url, JSON.stringify(query), {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.error(error)
      return 0
    }
  },
  async searchKeyPrefixAndConditionCount(db, key, query) {

    db = this.changeDatabaseNameByCid(db)

    try {
      const token = await this.getToken()
      let url = `${iStoreSetting.iStoreUrl}/searchKeyPrefixAndCondition/${db}/${key}/count`
      const result = await axios.post(url, JSON.stringify(query), {
        headers: {Token: token},
      })
      return parseInt(result.data.count)
    } catch (error) {
      console.error(error)
      return 0
    }
  },
  // Save each define data to cid.config.db
  async saveNodeData(db, key, value, seq_id = null) {

    db = this.changeDatabaseNameByCid(db)

    const token = await this.getToken()
    try {
      let data
      // seq_id parameter will be used to save changes from Modal (when user clicks a row in "View Data" tab)
      if (seq_id !== null) {
        data = {
          key, value: value, seq_id: seq_id,
        }
      } else {
        data = {
          key, value: value,
        }
      }
      const url = `${iStoreSetting.iStoreUrl}/${db}`
      const result = await axios.put(url, data, {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.warn(error.response?.data.message)
      return null
    }
  },
  // Delete node data from cid.config.db
  // We are also using this to delete account data since the functionality is the same
  async deleteNodeData(db, key) {

    db = this.changeDatabaseNameByCid(db)

    const token = await this.getToken()
    try {
      const url = `${iStoreSetting.iStoreUrl}/${db}/${key}`
      const result = await axios.delete(url, {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.warn(error.response?.data.message)
      return null
    }
  },
  // Edit user account data in istoreui.db
  async editUserData(db, key, value, seq_id) {

    db = this.changeDatabaseNameByCid(db)

    const token = await this.getToken()
    try {
      let data = {
        key, value: JSON.stringify(value), seq_id: seq_id,
      }
      const url = `${iStoreSetting.iStoreUrl}/${db}`
      const result = await axios.put(url, data, {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.warn(error.response?.data.message)
      return null
    }
  },
  // List all db
  async listDB(isRetry = false) {
    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/listdb`
    try {
      const result = await axios.get(url, {
        headers: {Token: token},
      })
      if (result.data === undefined) {
        throw result
      } else {
        return result.data
      }
    } catch (error) {
      if (['902', '903'].includes(error.response.data?.result) && !isRetry) {
        // The isRetry argument in listDB() is necessary to prevent indefinite calls
        // Because sometimes we won't have problem with /gettoken endpoint, but it's possible to get 902 error from /listdb endpoint call
        await this.getToken(true)
        return await this.listDB(true)
      }
      throw error.response.data
    }
  },
  // list all cid
  async cidList(limit, offset) {
    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/paginate/cid/${limit}/${offset}`
    try {
      const result = await axios.get(url, {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.warn(error.response?.data.message)
      return null
    }
  },
  // List all CID-related db (ex: C200016.config.db, C200016.concio.db, ...)
  async listAllCidDB(dbType) {
    // If dbType is 'concio', then it should return C200016.concio, C200017.concio, ...
    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/listdb/.${dbType}`
    try {
      const result = await axios.get(url, {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.warn(error.response?.data.message)
      return null
    }
  },
  // Create new db
  async createDB(newDbName, dbToken = '') {
    const token = await this.getToken(true)
    const url = `${iStoreSetting.iStoreUrl}/createdb`
    try {
      let data = {
        dbName: newDbName,
        token: dbToken,
        maxHop: 0,
        keepForDays: 0,
        sync: [],
        secondary: [],
      }
      const result = await axios.post(url, JSON.stringify(data), {
        headers: {Token: token},
      })
      return result
    } catch (error) {
      console.warn(error.response?.data.message)
      return null
    }
  },
  // Get all accounts count in istoreui.db
  async existsAccount(db) {

    db = this.changeDatabaseNameByCid(db)

    const token = await this.getToken()
    let url = `${iStoreSetting.iStoreUrl}/searchkeyprefix/${db}/${db}.account/count`
    try {
      const result = await axios.get(url, {
        headers: {Token: token},
      })
      return parseInt(result.data?.count)
    } catch (error) {
      //if (['902', '903'].includes(error.response.data?.result)) {
      //  await this.getToken(true)
      //  return await this.existsAccount(db)
      //}
      return 0
    }
  },
  // Create new account in istoreui.db
  async createNewAccount(account, pwd, cid, role) {
    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/istoreui`
    try {
      const pxd = iStoreUtils.sha512(pwd)
      const dateOfEmployment = new Date().toISOString().split('T')[0]
      let data = {
        key: `istoreui.account.${account}.${pxd}`,
        value: JSON.stringify({
          'userId': account,
          'userName': account,
          'pxd': pxd,
          'email': account,
          'userStatus': 'Activate',
          'dateOfEmployment': dateOfEmployment,
          'roles': [role],
          'roleNames': [role],
          'cids': cid,
          'updatedBy': account,
          'createdBy': account
        }),
      }
      const result = await axios.post(url, data, {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // Check if an account exists in istoreui.db
  async checkAccount(acc) {
    const token = await this.getToken()
    let url = `${iStoreSetting.iStoreUrl}/searchkeyprefix`
    try {
      let data = {
        database: 'istoreui',
        value: `istoreui.account.${acc}`,
        limit: 1,
        offset: 0,
      }
      const result = await axios.post(url, data, {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // Do login (using new login API)
  async loginAccount(account, p) {
    const pxd = iStoreUtils.sha512(p)
    const token = await this.getToken()
    try {
      let loginUser
      const result = await axios.post(
        `${iStoreSetting.iStoreUrl}/istoreui/api/login`,
        {
          key: `${account}.${pxd}`,
        },
        {
          headers: {Token: token},
        }
      )
      if (!result.data.result) {
        loginUser = JSON.parse(JSON.stringify(result.data))
        iStoreLocalData.setToken(loginUser.token) // Set login user token as new token, and save to local storage
        return loginUser
      } else {
        throw new Error(result.data.message)
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // Do login (using new login API)
  async getFunction() {
    try {
      const token = await this.getToken()
      const result = await axios.get(
        `${iStoreSetting.iStoreUrl}/istoreui/api/getFunction`,
        {
          headers: {Token: token},
        }
      )
      if (result.status) {
        return result.data
      } else {
        throw new Error(result.message)
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // Do login with CID (using new login API)
  async loginAccountWithCid(account, p, selectCid) {
    const pxd = iStoreUtils.sha512(p)
    //const token = await this.getToken()
    try {
      let loginUser
      const result = await axios.post(
        `${iStoreSetting.iStoreUrl}/istoreui/api/login`,
        {
          key: `${account}.${pxd}`,
        },
      )
      if (!result.data.result) {
        loginUser = result.data
        iStoreLocalData.setToken(loginUser.token) // Set login user token as new token, and save to local storage
        if (!loginUser.cids.includes(selectCid)) { // Check if selectCid is in loginUser.cids
          throw new Error(langControl.currentLangKey['notifNoCidFound'])
        }
        loginUser.cid = selectCid
        return loginUser
      } else {
        throw new Error(result.data.message)
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // Handle extend token, in case user still active within token timeout interval
  async extendToken() {
    const token = await this.getToken()
    try {
      const result = await axios.post(
        `${iStoreSetting.iStoreUrl}/istoreui/api/extendtoken`,
        {
          token: token,
        },
        {
          headers: {Token: token},
        })
      if (!result.data.result) {
        iStoreLocalData.setToken(result.data.token) // Save extended token to local storage
        return result.data.expiry
      } else {
        throw new Error(result.data.message)
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // Handle logout API
  async logOutAccount(star_number) {
    if (!star_number) {
      return
    }
    document.querySelectorAll('iframe').forEach(iframe => iframe.remove());

    const token = await this.getToken()
    try {
      const result = await axios.post(
        `${iStoreSetting.iStoreUrl}/istoreui/api/logout`,
        {
          starNumber: star_number,
        },
        {
          headers: {Token: token},
        })
      if (result.status !== 200) {
        throw new Error(result.data.message)
      }
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  // To change cid's account password in istoreui.db
  async changePxd(newPxd, oldUserData) {
    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/istoreui`
    try {      
      newPxd = iStoreUtils.sha512(newPxd)
      let data = {
        key: `istoreui.account.${oldUserData.value.userId}.${newPxd}`,
        value: JSON.stringify({...oldUserData.value, pxd: newPxd}),
      }
      const result = await axios.post(url, data, {
        headers: {Token: token},
      })
      await axios.delete(`${url}/${oldUserData.key}`, {
        headers: {Token: token},
      })
      return result.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async exportData(data) {
    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/istoreui/api/export`
    try {
      const result = await axios.post(url, data, {
        headers: {Token: token},
        responseType: "blob"
      })
      return result
    } catch(error) {
      console.error("[exportData] ERROR: ", error)
    }
  },
  // To edit db config in remote server
  async replaceConfig(status, config) {
    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/replaceconfig/${status}`
    if (status === 'download') {
      try {
        const result = await axios.post(url, null, {
          headers: {
            Token: `${token}`,
          },
        })
        return result.data
      } catch (error) {
        console.error(error)
        throw error
      }
    } else if (status === 'upload') {
      const jsonConfig = JSON.stringify(config)
      const blob = new Blob([jsonConfig], {type: 'application/json'})
      const formData = new FormData()
      formData.append('file', blob, 'config.json')
      try {
        const result = await axios.post(`${iStoreSetting.iStoreUrl}/replaceconfig/${status}`, formData, {
          headers: {
            Token: `${token}`,
          },
        })
        return result.data
      } catch (error) {
        console.error(error)
        throw error
      }
    }
  },
  async uploadFile(data, onUploadProgress = null) {
    // The 'data' must be a FormData Object
    const token = await this.getToken()
    const config = {
      headers: { Token: token },
    }
    // Only add onUploadProgress if it was provided
    if (onUploadProgress) {
      config.onUploadProgress = onUploadProgress
    }
    const url = `${iStoreSetting.iStoreUrl}/file/upload`
    return await axios.post(url, data, config)
  },
  async downloadData(db,filename){

    db = this.changeDatabaseNameByCid(db)

    try {
      const token = await this.getToken()
      const config = {
        headers: { Token: token },
      }
      let url
      if (filename !== null) {
        url = `${iStoreSetting.iStoreUrl}/file/${filename}`
        const result = await axios.get(url, config)
        return result.data
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async downloadDataCloud(db,filename){

    db = this.changeDatabaseNameByCid(db)

    try {
      const token = await this.getToken()
      const config = {
        headers: { Token: token },
      }
      let url
      if (filename !== null) {
        url = `${iStoreSetting.iStoreCloud}/file/${filename}`
        const result = await axios.get(url, config)
        return result.data
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async installBin(db,fileUrl){

    db = this.changeDatabaseNameByCid(db)
    try {
      const token = await this.getToken()
      const config = {
        headers: { Token: token },
      }
      let url
      if (fileUrl !== null) {

        let data = new FormData
        data.append('filename', fileUrl)
        url = `${iStoreSetting.iStoreUrl}/installingPlugin/`
        const result = await axios.post(url, data, config)
        return result.data
      }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async validateKey(data){
    try {
      
      const token = await this.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      let url
      if (data !== null) {
        url = `${iStoreSetting.iStoreUrl}/indexserver/cloud/license/validate`
        const result = await axios.post(url, data, config)
        return result
        } else {
          console.error("data is null")
          return null
        }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async generateKey(data){
    try {
      
      const token = await this.getToken()
      const config = {
        headers: {
          Token: token,
        },
      }
      let url
      if (data !== null) {
        url = `${iStoreSetting.iStoreUrl}/indexserver/local/license/generate`
        const result = await axios.post(url, data, config)
        return result.data
        } else {
          console.error("data is null")
          return null
        }
    } catch (error) {
      console.error(error)
      return null
    }
  },
  async put(db, data) {

    db = this.changeDatabaseNameByCid(db)

    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/${db}`
    return await axios.put(url, data, {
      headers: {Token: token},
    })
  },
  async putBatch(db, data) {
    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/${db}/batch`
    return await axios.put(url, data, {
      headers: {Token: token},
    })
  },
  async postBatch(db, data) {
    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/multiple/${db}`
    return await axios.post(url, data, {
      headers: {Token: token},
    })
  },
  async delete(db, key) {

    db = this.changeDatabaseNameByCid(db)

    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/${db}/${key}`
    return await axios.delete(url, {
      headers: {Token: token},
    })
  },
  async deleteBatch(db, key) {

    db = this.changeDatabaseNameByCid(db)

    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/${db}/${key}/batch`
    return await axios.delete(url, {
      headers: {Token: token},
    })
  },
  async deleteBatchByKey(db, dataList) {

    db = this.changeDatabaseNameByCid(db)

    const token = await this.getToken()
    const url = `${iStoreSetting.iStoreUrl}/${db}/batch`
    return await axios.delete(url, {
      data: dataList,
      headers: { Token: token },
    })
  },
  async getDatabase(db, token = "") {

    db = this.changeDatabaseNameByCid(db)

    if (!token) {
      token = await this.getToken(false)
    }
    const url = `${iStoreSetting.iStoreUrl}/${db}`
    return await axios.get(url, {
      headers: {Token: token},
    })
  },
  async getDatabasePaginate(db, offset, limit) {

    db = this.changeDatabaseNameByCid(db)

    const token = await this.getToken(false)
    const url = `${iStoreSetting.iStoreUrl}/paginate/${db}/${limit}/${offset}`
    return await axios.get(url, {
      headers: {Token: token},
    })
  },

  changeDatabaseNameByCid(db) {
    // Old CID format: Cxxxxx, 'C' followed by series of numbers
    // if (db.match(/^C[0-9]+\./) != null) {
    //   console.debug('#[saveNodeData] before db:', db)
    //   db = db.replace(/^C[0-9]+\./, $store.state.loginUser.cid + '.')
    //   console.debug('#[saveNodeData] after db:', db)
    // }
    // New CID format: no 'C' is added in front of numbers
    if (db.match(/^[0-9]+\./) != null) {
      console.debug('#[saveNodeData] before db:', db)
      db = db.replace(/^[0-9]+\./, $store.state.loginUser.cid + '.')
      console.debug('#[saveNodeData] after db:', db)
    }
    return db
  },

  buildSearchCondition(query, searchTerm, define) {
    if (!query.condition) {
      query.condition = []
    }
    console.debug('#[getDataBySearchTerm] searchTerm:%s, define:%O', searchTerm, define)
    if (searchTerm && searchTerm.length >= 2 && define.columns) {
      for (let column of define.columns) {
        if (column.showInSearch) {
          console.debug(column)
          console.debug(query.condition.length)
          query.condition.push({
            'column': column.name,
            'condition': 'like',
            'value': `%${searchTerm}%`,
            andOr: 'or',
          })
        }
      }
    }
    console.debug(query)
  },

  async getSelf() {
    try {
      const token = await this.getToken()
      let url = `${iStoreSetting.iStoreUrl}/indexserver/self`
      const result = await axios.get(url, {
        headers: {Token: token},
      })
      if (result.data) {
        return result.data
      }
    } catch (error) {
      console.error("getSelf error: ", error)
    }
    return {}
  },
}
